import { render, staticRenderFns } from "./CompanyType.vue?vue&type=template&id=15d7d609"
import script from "./CompanyType.vue?vue&type=script&lang=js"
export * from "./CompanyType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports